<template>
  <div class="comp-qf-body-summary">
    <div class="qf-table-fixed-left" :style="{ minHeight: rowHeight + 'px', width: `${fixedLeftWidthAll}px` }" :class="{ 'scroll-left-shadow': scrollShadowLeft }">
      <template v-for="(col, index) in colLeft" :key="col.colKey">
        <qf-body-summary-cell :style="{ width: col.width + 'px', flex: index === 0 ? 1 : 'none' }" :column="col" :aggregationType="col.aggregationType" :value="summaryData[col.colKey]" :formatter="summaryOptions.formatter" @change="onChange" />
      </template>
    </div>
    <div class="qf-table-content" v-if="hasMiddleColumns" :style="{ minHeight: rowHeight + 'px' }">
      <template v-for="col in colMiddle" :key="col.colKey">
        <div v-if="col.children?.length" class="sub-form-body">
          <template v-for="group in col.children" :key="group.colKey">
            <qf-body-summary-cell :style="{ width: group.width + 'px' }" :column="group" :aggregationType="group.aggregationType" notSupported :value="summaryData[group.colKey]" :formatter="summaryOptions.formatter" @change="onChange" />
          </template>
        </div>
        <template v-else>
          <qf-body-summary-cell :style="{ width: col.width + 'px' }" :column="col" :aggregationType="col.aggregationType" :value="summaryData[col.colKey]" :formatter="summaryOptions.formatter" @change="onChange" />
        </template>
      </template>
    </div>
    <div class="qf-table-fixed-right" v-if="hasRightColumns" :class="{ 'scroll-right-shadow': scrollShadowRight }">
      <template v-for="col in colRight" :key="col.colKey">
        <qf-body-summary-cell :style="{ width: col.width + 'px' }" :column="col" :aggregationType="col.aggregationType" :value="summaryData[col.colKey]" :formatter="summaryOptions.formatter" @change="onChange" />
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, inject } from 'vue';
import QfBodySummaryCell from '../qf-body-summary-cell/qf-body-summary-cell.vue';

const props = defineProps({
  columns: {
    type: Array,
    default: () => []
  }
});

const rowHeight = ref(0);
const scrollShadowLeft = ref(inject('qfTable')?.scrollShadowLeft);
const scrollShadowRight = ref(inject('qfTable')?.scrollShadowRight);
const fixedLeftWidth = inject('qfTable')?.fixedLeftWidth;
const summaryOptions = inject('qfTable')?.summaryOptions;
const summaryData = computed(() => summaryOptions.value?.data || {});

// 计算列的固定位置
const colLeft = computed(() => props.columns?.filter((v) => v.fixed === 'left'));
const colMiddle = computed(() => props.columns?.filter((v) => v.fixed !== 'left' && v.fixed !== 'right'));
const colRight = computed(() => props.columns?.filter((v) => v.fixed === 'right'));

const fixedLeftWidthAll = computed(() => {
  return colLeft.value?.reduce((pre, cur) => pre + cur.width, fixedLeftWidth.value);
});

// 是否有中间列
const hasMiddleColumns = computed(() => colMiddle.value?.length);

// 是否有右固定列
const hasRightColumns = computed(() => colRight.value?.length);

const onChange = (data) => {
  summaryOptions.value?.onChange?.(data);
};
</script>
<style scoped lang="less">
@import './qf-body-summary.less';
</style>
